module.exports = __webpack_public_path__ + "static/img/jigou-1-bottom.0a0df97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou-1-bottom.png
// module id = xAgj
// module chunks = 2